import { Injectable, Optional } from '@angular/core';

import { PreviousPageLocationCacheService } from '../../client-caching/previous-page-cache.service';
import { FixtureList } from '../../competition-list/competition.models';
import { CompetitionOverview } from '../../competition-list/services/competition-list.service';
import { ChildDependencyResolver } from '../../dependency/child-dependency.resolver';
import { TournamentEventsService } from '../../tournament/tournament-events.service';
import { TournamentOverviewService } from '../../tournament/tournament-overview.service';
import type { TournamentViewModel } from '../../tournament/tournament.models';

@Injectable({ providedIn: 'root' })
export class TournamentResolver extends ChildDependencyResolver<CompetitionOverview, TournamentViewModel> {
    constructor(dependencyService: TournamentOverviewService, @Optional() previousPageLocationCacheService: PreviousPageLocationCacheService) {
        super(dependencyService, previousPageLocationCacheService);
    }
}

@Injectable({ providedIn: 'root' })
export class TournamentEventsResolver extends ChildDependencyResolver<CompetitionOverview, FixtureList | undefined> {
    constructor(dependencyService: TournamentEventsService, @Optional() previousPageLocationCacheService: PreviousPageLocationCacheService) {
        super(dependencyService, previousPageLocationCacheService);
    }
}
